module.exports = __webpack_public_path__ + "static/media/aq.cf7e3b9a.svg";